import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Handle, Position, useUpdateNodeInternals } from 'reactflow';
import { useSelector } from 'react-redux';

const SwitchNode = ({ data, id, isConnectable }) => {
  const [handleCount, setHandleCount] = useState([]);
  const [switchInput, setSwitchInput] = useState([]);
  const sourceArray = useSelector((state) => state.flow.switchHandleCount);
  const switchList = useSelector((state) => state.flow.switchListe);

  useEffect(() => {
    const filtered = sourceArray.find((item) => item.id === id);
    if (filtered) setHandleCount(filtered.CountDizi);
    const filteredSwitch = switchList.find((item) => item.id === id);
    if (filteredSwitch) setSwitchInput(filteredSwitch.switchInput);
  }, [id, sourceArray, switchList]);

  const updateNodeInternals = useUpdateNodeInternals();
  const nodeRef = useRef();
  useLayoutEffect(() => { updateNodeInternals(id); }, [handleCount, id, updateNodeInternals]);

  const subline = data.Title !== undefined ? data.Title : '';
  const sourceHandles = useMemo(() => handleCount.map((_, i) => {
    const handleId = `${id}-switch-source-handle-${i + 1}`;
    const position = (i + 1) / (handleCount.length + 1);
    const caseValue = switchInput[i]?.value || `Case ${i + 1}`;
    return (
      <div key={handleId} style={{ position: 'absolute', left: `${position * 100}%`, bottom: 0, transform: 'translateX(-50%)' }}>
        <div style={{ position: 'absolute', bottom: -10, left: '50%', transform: 'translateX(-50%)', fontSize: 10, whiteSpace: 'nowrap' }}>{caseValue}</div>
        <Handle id={handleId} type="source" position={Position.Bottom} isConnectable={isConnectable} style={{ bottom: -15, transform: 'translateY(50%)' }} />
      </div>
    );
  }), [handleCount, id, isConnectable, switchInput]);

  return (
    <div className="wrapper gradient" style={{ position: 'relative' }}>
      <Handle id="in" type="target" position={Position.Top} isConnectable={isConnectable} style={{ top: 2, transform: 'translateY(-50%)' }} />
      <div className="inner">
        <div className="body">
          <div>
            <div className="title">{data.label}</div>
            {subline && <div className="subline">{subline}</div>}
          </div>
        </div>
        <div ref={nodeRef} style={{ position: 'relative', height: 20 }}>{sourceHandles}</div>
      </div>
    </div>
  );
};

export default SwitchNode;

